import { render, staticRenderFns } from "./Tip2.vue?vue&type=template&id=7ea440d4&"
import script from "./Tip2.vue?vue&type=script&lang=js&"
export * from "./Tip2.vue?vue&type=script&lang=js&"
import style0 from "./Tip2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports